// src/components/AdminShortcut.js

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function AdminShortcut() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleShortcut = (e) => {
      if (e.altKey && e.shiftKey && e.key.toLowerCase() === "l") {
        navigate("/admin/login");
      }
    };

    window.addEventListener("keydown", handleShortcut);

    return () => {
      window.removeEventListener("keydown", handleShortcut);
    };
  }, [navigate]);

  return null;
}

export default AdminShortcut;